import { CreateAssetDropdownMenu } from "#src/batteries-included-components/Buttons/CreateAssetDropdownMenu/CreateAssetDropdownMenu";
import DeviceList from "#src/batteries-included-components/Layouts/Devices/List/DeviceList";
import useLocalization from "#src/hooks/useLocalization";
import { DevicesListRoutePath } from "#src/routes/organization/devices";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { generateDocumentTitle, Page } from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

export const DeviceListPage = () => {
  const { localize } = useLocalization();
  const { isLoading: isMappingLoading } = useLocalization();
  const [breadcrumbs] = useBreadcrumbsFromRoute(DevicesListRoutePath);

  const actionRow = <CreateAssetDropdownMenu assetType={AssetType.DEVICE} />;

  return (
    <Titled title={generateDocumentTitle(localize("device_plural"))}>
      <Page
        category={DevicesListRoutePath.subtitle}
        title={localize("device_plural")}
        breadcrumbs={breadcrumbs}
        actionRow={actionRow}
        isLoading={isMappingLoading}
      >
        <DeviceList />
      </Page>
    </Titled>
  );
};

DeviceListPage.displayName = "DeviceListPage";
